import { TruncatedTextWithTooltip } from "components/cell-renders";
import DeletedSubmittalTag from "components/deleted-submittal-tag";
import { Link, useParams } from "react-router-dom";

export function InnerIdLinkSubmittalRenderer(param: any) {
  const { projectId } = useParams() as any;
  const { data, value } = param;
  return (
    <div className="flex items-center justify-center">
      {data?.deleted_from_source && <DeletedSubmittalTag />}
      <Link
        className={
          data?.deleted_from_source ? "gridIdDeletedSubLink" : "gridIdLink"
        }
        target="_blank"
        to={{
          pathname: `/project/${projectId}/submittals/${data.id}`
        }}
      >
        {value}
      </Link>
    </div>
  );
}

export function InnerIdLinkMaterialRenderer(param: any) {
  const { projectId } = useParams() as any;
  const { data, value } = param;
  return (
    <Link
      className="gridIdLink"
      target="_blank"
      to={{
        pathname: `/project/${projectId}/materials/${data.id}`
      }}
    >
      <TruncatedTextWithTooltip text={value} />
    </Link>
  );
}
